module.exports = __webpack_public_path__ + "img/Text Background 2.04a1ec1f.png";